import { Row, Col, Container } from "react-bootstrap";
import { TableOfContents } from "../../../api"
import "./TableOfContentsItem.css"
import LabelAndTextBox from "../../molecules/labelandtextbox/LabelAndTextBox";
import NumberBox from "../../molecules/labelandtextbox/NumberBox";

interface TableOfContentsProps {
    tableOfContents?: TableOfContents;
    projectNumber: string;
    disabled?: boolean;
}


const TableOfContentsItem: React.FC<TableOfContentsProps> = (props) => {
    return (
        <div className="shadow">
            <Container className="align-items-center p-5 tablecolor">
                <Row className="d-flex gap-3 flex-wrap">
                    <Col xs={12} sm={12} md={10} lg={5} xl={5} className="sideBorder">
                        <h4 className="fw-bold fs-5 mt-2">Projektnummer</h4>
                        <p className="fs-5 fs-md-2">{props.projectNumber}</p>
                        <LabelAndTextBox title="Projektnamn" remark={props.tableOfContents?.projectName} onChange={(value) => props.tableOfContents!.projectName = value} disabled={props.disabled} />
                        <LabelAndTextBox title="Projektadress" remark={props.tableOfContents?.projectAddress} onChange={(value) => props.tableOfContents!.projectAddress = value} disabled={props.disabled} />
                        <Row>
                            <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                                <NumberBox title="Kvadratmeter" defaultValue={props.tableOfContents?.squareMeters} onChange={(value) => props.tableOfContents!.squareMeters = value} disabled={props.disabled} />
                            </Col>
                            <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                                <NumberBox title="Tillträdesleder" defaultValue={props.tableOfContents?.accessRoutes} onChange={(value) => props.tableOfContents!.accessRoutes = value} disabled={props.disabled} />
                            </Col>
                        </Row>
                    </Col>
                    <Col className="mx-3" xs={12} sm={12} md={10} lg={5} xl={5}>
                        <Row>FAKTA STÄLLNING</Row>
                        <Row>EGENKONTROLL STÄLLNING</Row>
                        <Row>PLAN FÖR UPPFÖRANDE, ANVÄNDNING OCH MONTERING AV STÄLLNING</Row>
                        <Row>GENERELL RISKBEDÖMNING</Row>
                        <Row>RÄDDNINGSPLAN</Row>
                        <Row>TÄNK 5</Row>
                        <Row>BLANDNINGSUTREDNING</Row>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default TableOfContentsItem;